import React from 'react';
import { Table, Col, Row, Button, Modal, Input, Checkbox, message, DatePicker, Descriptions, Select } from 'antd';
import axios from 'axios';
import moment from 'moment';
import {
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

import { round2 } from '@/utils/tools';

import './Stock.scss'

const { confirm } = Modal;
const { Option } = Select;
const accountMap = {}

interface IProps {
  userStore: any
}
interface IState {}

@inject('userStore')
@observer
class Stock extends React.PureComponent<IProps, IState>  {
  state = {
    columns: [{
      title: '中签时间',
      dataIndex: 'date',
      key: 'date',
      render: (value) => {
        return value.substring(0, 10)
      }
    }, {
      title: '新股名称',
      dataIndex: 'newName',
      key: 'newName'
    }, {
      title: '新股缴费',
      dataIndex: 'ballotFund',
      key: 'ballotFund'
    }, {
      title: '新股收益',
      dataIndex: 'newBonus',
      key: 'newBonus'
    }, {
      title: '新股收益率',
      dataIndex: 'yield',
      key: 'yield',
      render: (value) => {
        return (value * 100).toFixed(2) + '%';
      }
    }, {
      title: '货币单位',
      dataIndex: 'currency',
      key: 'currency'
    }, {
      title: '操作',
      width: '130px',
      fixed: 'right' as const,
      render: (val, recorder) => {
        return (
          <React.Fragment>
            <span className='table-warning' onClick={ () => { this.modifyeNew(recorder) } }>编辑</span>
            <span className='table-delete' onClick={ () => { this.deleteNew(recorder._id) } }>删除</span>
          </React.Fragment>
        )
      }
    }],
    dataSource: [],
    newModal: 0,
    stockAccounts: [],
    newName: '',
    date: moment(`${ (new Date()).getFullYear() }-${ (new Date()).getMonth() + 1 }-${ (new Date()).getDate() }`, 'YYYY-MM-DD'),
    accountPro: {},
    allProByCurrency: {},
    hkdRate: 0,
    modifyId: '',
    belongToId: '',
    newBonus: '',
    ballotFund: '',
    currency: 'RMB',
    stockMap: {},
    selectYear: (new Date()).getFullYear(),
    gridYear: [],
  }

  deleteNew = (id) => {
    confirm({
      title: 'Are you sure delete this task?',
      icon: <ExclamationCircleOutlined />,
      content: '确定删除？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk: () => {
        axios.delete(`/new/stock?_id=${ id }`).then((res) => {
          message.success('删除成功');

          this.getNewStock();
        }, () => {
          message.error('删除失败');
        });
      },
    });
  }

  modifyeNew = (rec) => {
    const stockAccounts = this.state.stockAccounts
    const gotAccount = {}
    let newName = ''

    Object.keys(rec).forEach((title) => {
      const matches = /^(\d+)name$/.exec(title)

      if (matches && !gotAccount.hasOwnProperty(matches[1])) {
        gotAccount[matches[1]] = rec[`${ matches[1] }value`]
        newName = rec[`${ matches[1] }name`]
      }
    })

    stockAccounts.forEach((account) => {
      if (gotAccount.hasOwnProperty(account.accountId)) {
        account.got = true
        account.earning = (gotAccount[account.accountId] || '') + ''
      }
    })

    this.setState({
      newModal: 2,
      modifyId: rec._id,
      date: moment(rec.date.substring(0, 10), 'YYYY-MM-DD'),
      newName: rec.newName,
      newBonus: rec.newBonus,
      ballotFund: rec.ballotFund,
      currency: rec.currency || 'RMB',
    })
  }

  getNewStock = () => {
    axios.get(`/new/stock?year=${ this.state.selectYear }`).then(((res) => {
      const ori = res.data
      const allProByCurrency: { [key: string]: number } = {};

      ori.forEach((tick) => {
        const currency = tick.currency || 'RMB';
        if (!allProByCurrency[currency]) {
          allProByCurrency[currency] = 0;
        }
        allProByCurrency[currency] += (+tick.newBonus);
      });

      this.setState({
        allProByCurrency: allProByCurrency,
        dataSource: ori,
      });
    }))
  }

  getHkdRate = () => {
    axios.get('/exRate').then((res) => {
      const list = res && res.data || [];

      if (list.length) {
        this.setState({ hkdRate: Number(list[0].HKD) || 0 });
      }
    })
  }

  handleChange = (pos, key, value) => {
    const stockAccounts = this.state.stockAccounts

    stockAccounts[pos][key] = value

    this.setState({ stockAccounts: [...stockAccounts] })
  }

  addNew = () => {
    this.setState({
      newModal: 1,
      newName: '',
      newBonus: '',
      ballotFund: '',
      currency: 'RMB',
    })
  }

  searchStock = () => {
    this.getNewStock();
  }

  handleOk = () => {
    if (!this.state.newName || !this.state.newBonus || !this.state.date || !this.state.ballotFund) {
      message.error('输入')

      return
    }
    const info: any =  {
      date: new Date(this.state.date.format().substring(0, 10)),
      newName: this.state.newName,
      newBonus: this.state.newBonus,
      ballotFund: this.state.ballotFund,
      currency: this.state.currency,
    }
    let action

    if (this.state.newModal === 1) {
      action = axios.post
    } else {
      action = axios.put
      info._id = this.state.modifyId
    }

    action('/new/stock', info).then((res) => {
      message.success('操作成功');
      this.getNewStock();
      this.clearAddData();
    }, () => {
      message.error('操作失败');
    })

    this.handleCancel();
  }

  clearAddData = () => {
    const stockAccounts = this.state.stockAccounts

    stockAccounts.forEach((acc) => {
      acc.got = false
      acc.earning = ''
    })

    this.setState({
      stockAccounts: [...stockAccounts],
      newName: ''
    })
  }

  handleCancel = () => {
    this.setState({ newModal: 0 });
    this.clearAddData();
  }

  changeInput = (name, val) => {
    this.setState({
      [name]: val
    });
  }

  // 初始化时间
  initYear = () => {
    let thisYear = (new Date()).getFullYear();
    let years = [];

    new Array(thisYear - 2020).fill('1').forEach((item, ind) => {
      years.push(2020 + ind + 1);
    });

    this.setState({
      gridYear: years,
    });
  }

  componentDidMount() {
    this.initYear();
    this.getNewStock();
    this.getHkdRate();
  }

  render() {
    return (
      <div className='new-tick'>
        <div className='filter-row'>
          <Row gutter={ 16 }>
            <Col xs={ 24 } sm={ 12 } md={ 8 } lg={ 6 } xl={ 4 }>
              <Select value={ this.state.selectYear } style={{ width: '100%' }} onChange={ (value) => { this.changeInput('selectYear', value) } }>
                <Option value="">全部</Option>
                {
                  this.state.gridYear.map((item) => {
                    return (
                      <Option value={ item } key={ item }>{ item }年</Option>
                    )
                  })
                }
              </Select>
            </Col>
            <Col xs={ 24 } sm={ 12 } md={ 8 } lg={ 18 } xl={ 20 } className='button-group-col'>
              <Row gutter={ 16 } justify='end' className='button-group'>
                <Col xs={ 12 } sm={ 6 } md={ 4 } lg={ 2 } xl={ 2 }>
                  <Button type='primary' onClick={ this.searchStock } block>搜索</Button>
                </Col>
                <Col xs={ 12 } sm={ 6 } md={ 4 } lg={ 2 } xl={ 2 }>
                  <Button type='default' onClick={ this.addNew } block>新增</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <br />
        <Descriptions
          bordered
        >
          {
            (() => {
              const aProfit = this.state.allProByCurrency['RMB'] || 0;
              const hkProfit = this.state.allProByCurrency['HKD'] || 0;
              const totalRmb = aProfit + hkProfit * (this.state.hkdRate || 0);

              return (
                <React.Fragment>
                  <Descriptions.Item label='A股收益' key='RMB'>
                    { round2(aProfit) } RMB
                  </Descriptions.Item>
                  <Descriptions.Item label='港股收益' key='HKD'>
                    { round2(hkProfit) } HKD
                  </Descriptions.Item>
                  <Descriptions.Item label='总收益(RMB)' key='totalRMB'>
                    { round2(totalRmb) } RMB
                  </Descriptions.Item>
                </React.Fragment>
              )
            })()
          }
          {
            Object.keys(this.state.accountPro).map((id) => {
              return (
                <Descriptions.Item label={ accountMap[id] } key={ id }>{ round2(this.state.accountPro[id]) }</Descriptions.Item>
              )
            })
          }
        </Descriptions>
        <br />
        <Table
          bordered={ true }
          pagination={ false }
          dataSource={ this.state.dataSource }
          columns={ this.state.columns }
          rowKey={ item => item._id }
          scroll={{ x: true }}
        />
        {
          !!this.state.newModal && <Modal
            title={ this.state.newModal === 1 ? '新增' : '编辑' }
            visible={ !!this.state.newModal }
            onOk={ this.handleOk }
            onCancel={ this.handleCancel }
            width="840px"
          >
            <Row className='account-row'>
              <Col span={ 4 } className='must'>时间：</Col>
              <Col span={ 8 }>
                <DatePicker
                  style={{ width: '100%' }}
                  value={ this.state.date }
                  onChange={ (value) => { this.setState({ date: value })} }
                />
              </Col>
              <Col span={ 4 } className='must'>新股名称：</Col>
              <Col span={ 8 }>
                <Input value={ this.state.newName } onChange={ (e) => { this.setState({ newName: e.target.value }) } } />
              </Col>
            </Row>
            <Row className='account-row'>
              <Col span={ 4 } className='must'>新股缴款：</Col>
              <Col span={ 8 }>
                <Input value={ this.state.ballotFund } onChange={ (e) => { this.setState({ ballotFund: e.target.value }) } } />
              </Col>
              <Col span={ 4 } className='must'>新股收益：</Col>
              <Col span={ 8 }>
                <Input value={ this.state.newBonus } onChange={ (e) => { this.setState({ newBonus: e.target.value }) } } />
              </Col>
            </Row>
            <Row className='account-row'>
              <Col span={ 4 } className='must'>货币单位：</Col>
              <Col span={ 8 }>
                <Select 
                  value={ this.state.currency } 
                  style={{ width: '100%', textAlign: 'left' }} 
                  className="currency-select"
                  onChange={ (value) => { this.setState({ currency: value }) } }
                >
                  <Option value="RMB">人民币</Option>
                  <Option value="HKD">港币</Option>
                </Select>
              </Col>
            </Row>
            {
              this.state.stockAccounts.map((acc, ind) => {
                return (
                  <Row className='account-row' key={ acc.accountId }>
                    <Col span={ 1 }>
                      <Checkbox checked={ acc.got } onChange={ (e) => { this.handleChange(ind, 'got', e.target.checked ) } } />
                    </Col>
                    <Col span={ 4 }>{ acc.securitiesCompany + acc.accountId }</Col>
                    <Col span={ 2 }></Col>
                    <Col span={ 12 }>
                      <Input value={ acc.earning } onChange={ (e) => { this.handleChange(ind, 'earning', e.target.value ) } } disabled={ !acc.got } />
                    </Col>
                  </Row>
                )
              })
            }
          </Modal>
        }
      </div>
    )
  }
}

export default Stock;
